import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "contents1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  id: "contents1"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "com_inner1 clearfix" }
const _hoisted_7 = {
  key: 0,
  class: "error-message com_mgb10",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = { class: "com_block1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "エージェントコード"),
  /*#__PURE__*/_createElementVNode("p", { class: "com_fs12 com_color1" }, "※必須項目です")
], -1)
const _hoisted_10 = { class: "com_a_table1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"80%"} })
], -1)
const _hoisted_12 = { style: {"width":"5%"} }
const _hoisted_13 = { class: "com_checkbox3" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", null, "コード", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "エージェント名", -1)
const _hoisted_17 = { class: "com_checkbox3" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "com_block1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "請求年月/締め日"),
  /*#__PURE__*/_createElementVNode("p", { class: "com_fs12 com_color1" }, "※必須項目です")
], -1)
const _hoisted_21 = { class: "com_b_cnt1" }
const _hoisted_22 = { class: "com_f_group1" }
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"8px","margin-right":"8px"} }, "締め日", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "com_fs15 com_lh14 com_mgt10 com_mgb0" }
const _hoisted_28 = { class: "com_u_cnt1" }
const _hoisted_29 = { class: "com_inner1 clearfix" }
const _hoisted_30 = {
  key: 0,
  class: "com_inner1 clearfix com_mgt15"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 請求仕入合計ファイルを作成しました。ダウンロードリンクをクリックし、ファイルを保存してください。 ", -1)
const _hoisted_32 = { class: "div-kan com_mgb10" }
const _hoisted_33 = { style: {"display":"flex"} }
const _hoisted_34 = { style: {"width":"900px"} }
const _hoisted_35 = { class: "com_a_table1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, "エージェントコード"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"35%"} }, "エージェント名"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"45%"} }, "ダウンロードリンク")
  ])
], -1)
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _component_LoadingOverlayComponent = _resolveComponent("LoadingOverlayComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BreadcrumbsComponent, {
                title: '',
                categoryId: _ctx.categoryId
              }, null, 8, ["categoryId"]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createElementVNode("table", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _ctx.isAllChecked,
                              class: "check_all1",
                              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAllAgents && _ctx.toggleAllAgents(...args)))
                            }, null, 40, _hoisted_14)
                          ])
                        ]),
                        _hoisted_15,
                        _hoisted_16
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agList, (agent, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("label", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((agent.selection) = $event),
                                class: "check_all1"
                              }, null, 8, _hoisted_18), [
                                [_vModelCheckbox, agent.selection]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(agent.agCode), 1),
                          _createElementVNode("td", null, _toDisplayString(agent.agName), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedYear) = $event)),
                        class: "com_f_control1"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearOptions, (year) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: year,
                            value: year
                          }, _toDisplayString(year) + "年 ", 9, _hoisted_23))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedYear]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                        class: "com_f_control1"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthOptions, (month) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: month,
                            value: month
                          }, _toDisplayString(String(month).padStart(2, "0")) + "月 ", 9, _hoisted_24))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedMonth]
                      ]),
                      _hoisted_25,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCloseDay) = $event)),
                        class: "com_f_control1"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closeDayOptions, (closeDay) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: closeDay,
                            value: closeDay
                          }, _toDisplayString(closeDay === "99"
                        ? "月末"
                        : String(closeDay).padStart(2, "0") + "日"), 9, _hoisted_26))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedCloseDay]
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.getValueById(
                    _ctx.displayMessages,
                    _ctx.SeikyuRptDownloadConstants.KEY_DISPLAY_TEXT_BILLING_CLOSE_NOTE
                  )), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'ReportDownload' },
                      class: "com_link2 b",
                      style: {"margin-left":"12px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("各種ダウンロードへ戻る")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnSerch",
                      class: "com_search_button1",
                      style: {"width":"220px"},
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSerch && _ctx.onSerch(...args)))
                    }, " 請求仕入合計検索 "),
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnClear",
                      class: "com_clear_button1",
                      style: {"width":"120px","margin-right":"12px"},
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                    }, " クリア ")
                  ])
                ])
              ])
            ]),
            (_ctx.outputDataList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "btnDownload",
                          class: "uri_res_button1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.onDownload(
                    _ctx.SeikyuRptDownloadConstants.DOWNLOAD_TYPE_ZIP,
                    _ctx.zipFileName
                  )
                ))
                        }, " 全ファイルダウンロード ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("table", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outputDataList, (data, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(data.agCode), 1),
                            _createElementVNode("td", null, _toDisplayString(data.agName), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "com_link1",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.onDownload(
                        _ctx.SeikyuRptDownloadConstants.DOWNLOAD_TYPE_TSV,
                        data.rptName
                      )
                    ), ["prevent"])
                              }, _toDisplayString(data.rptName), 9, _hoisted_37)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingOverlayComponent, {
          key: 2,
          lines: _ctx.loadLines
        }, null, 8, ["lines"]))
      : _createCommentVNode("", true)
  ], 64))
}